// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RyUh","left":"styles_left__1-6wz","desktopActions":"styles_desktopActions__3yoAo","title":"styles_title__1S9h8"};